import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  CandidateDna,
  RoleThatFits,
} from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-profile.model';

@Injectable({ providedIn: 'root' })
export class DnaProfileService extends ApiService {
  constructor() {
    super();
    this.url = 'candidate-dna/';
  }

  getCandidateDna(id: number): Observable<CandidateDna> {
    return this.get({ id });
  }

  // TODO FA-1073: path not agreed with BE yet; fastr-service has no roles-that-fit route.
  getRolesThatFit(id: number): Observable<RoleThatFits[]> {
    return this.get<RoleThatFits[]>({ url: `${id}/roles-that-fit` });
  }
}
